<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-button type="primary" size="large" @click="fnPopCreate()">新增大区</el-button>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="名称" prop="name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnEditClass(row)">编辑</el-button>
            <el-button type="text" @click="fnDeleteClass(row.class_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetShopList" />
    </div> -->

    <el-dialog title="大区" :visible.sync="bCreateReply" width="70%">
      <el-form :model="classForm" class="fn-clear">
        <el-form-item label="大区名称">
          <el-input v-model="classForm.name" />
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="fnSubmitCreate()">提交</el-button>
    </el-dialog>
  </div>

</template>
<script>

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'ShopClassList',
  data() {
    return {
      lists: [],
      tableKey: 0,
      total: 0,
      bCreateReply: false,
      classForm: {
        class_id: '',
        name: ''
      }
    }
  },
  created() {
    this.fnGetShopList()
  },
  methods: {
    fnGetShopList: function() {
      this.bCreateReply = false
      this.$http.getShopClassList().then(res => {
        this.lists = res.data
      })
    },
    fnPopCreate() {
      this.classForm.class_id = ''
      this.classForm.name = ''
      this.bCreateReply = true
    },
    fnSubmitCreate: function() {
      this.$http.improveShopClass(this.classForm).then(res => {
        this.fnGetShopList()
      })
    },
    fnDeleteClass(class_id) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.delShopClass({ class_id }).then(res => {
          this.fnGetShopList()
        })
      })
    },
    fnEditClass(cls) {
      this.classForm.class_id = cls.class_id
      this.classForm.name = cls.name
      this.bCreateReply = true
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
